'use client';

interface StepBarProps {
  step: number;
}

export default function StepBar({ step }: StepBarProps) {
  return (
    <div className="p-step-bar">
      <div className={`p-step-bar__item ${step === 1 ? '-active' : ''}`}>
        <div className="p-step-bar__text">STEP1</div>
      </div>
      <div className={`p-step-bar__item ${step === 2 ? '-active' : ''}`}>
        <div className="p-step-bar__text">STEP2</div>
      </div>
      <div className={`p-step-bar__item ${step === 3 ? '-active' : ''}`}>
        <div className="p-step-bar__text">完了</div>
      </div>
    </div>
  );
}
